import clsx from 'clsx';
import {
    COMMUNITY_ANALYSES,
    COMMUNITY_LOBBY,
    COMMUNITY_POSTS_AUTHOR,
    BETBOOK_TICKETS,
    COMMUNITY_TOP_EVENTS,
    BONUS_DASHBOARD_CURRENT,
    BONUS_DASHBOARD_HISTORY,
    CASINO_FAVORITE,
    CASINO_GAME_DETAIL,
    CASINO_GAME_HRY_CATEGORY,
    CASINO_GAME_KASINO_CATEGORY,
    CASINO_HELP,
    CASINO_HISTORY,
    CASINO_HRY_LOBBY,
    CASINO_LOBBY,
    CASINO_MARKETING_ARTICLE,
    HELP_MENU,
    LEGAL_INFORMATION,
    MENU,
    MESSAGES,
    NIKE1_DETAIL,
    NIKE1_MATCH,
    SCRATCHCARD_OVERVIEW,
    TOURNAMENTS,
    TOURNAMENTS_RANKING,
    TOURNAMENTS_REWARDS,
    TURBO_LIVE_SPORT,
    TV_NIKE_ARCHIVE_DETAIL,
    TV_NIKE_HIGHLIGHTS_DETAIL
} from '@/routing/routes';
import { isRegistrationRoute } from '@/routing/routeutils';

const grey = [
    COMMUNITY_LOBBY,
    COMMUNITY_ANALYSES,
    //BETBOOK_BLOGS,
    BETBOOK_TICKETS,
    COMMUNITY_POSTS_AUTHOR,
    MESSAGES,
    BONUS_DASHBOARD_CURRENT,
    BONUS_DASHBOARD_HISTORY,
    TOURNAMENTS,
    TOURNAMENTS_REWARDS,
    TOURNAMENTS_RANKING,
    LEGAL_INFORMATION,
    HELP_MENU,
    CASINO_FAVORITE,
    CASINO_GAME_DETAIL,
    CASINO_HISTORY,
    CASINO_HELP,
    CASINO_MARKETING_ARTICLE,
    CASINO_GAME_KASINO_CATEGORY,
    CASINO_GAME_HRY_CATEGORY,
    CASINO_HRY_LOBBY,
    CASINO_LOBBY,
    COMMUNITY_TOP_EVENTS,
    SCRATCHCARD_OVERVIEW
];

const noMin = [MENU, TURBO_LIVE_SPORT, SCRATCHCARD_OVERVIEW];

const fullMin = [NIKE1_DETAIL, NIKE1_MATCH];

export function pageClassnames(route) {
    return clsx({
        'ph-min': !noMin.includes(route) && !fullMin.includes(route) && !isRegistrationRoute(route),
        'phf-min': fullMin.includes(route),
        'grey-bg': grey.includes(route),
        'nike-tv-archive-detail': route === TV_NIKE_ARCHIVE_DETAIL || route === TV_NIKE_HIGHLIGHTS_DETAIL
    });
}

export function fullPageClassnames(route) {
    return clsx({
        'page-registration': isRegistrationRoute(route)
    });
}
